import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Gerar Conta Pagar", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Buscar Comissões", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ss-tela-conteudo" }
const _hoisted_11 = { class: "ss-card ss-card-space" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_16 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_17 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_18 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, null, -1)
const _hoisted_21 = {
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"40%"}
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_31 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_32 = { class: "ant-input-suffix" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1)
const _hoisted_34 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_37 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_38 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_spam = _resolveComponent("spam")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_tipo_data_comissao = _resolveComponent("selecionar-tipo-data-comissao")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_tipo_comissao = _resolveComponent("selecionar-tipo-comissao")!
  const _component_selecionar_colaborador = _resolveComponent("selecionar-colaborador")!
  const _component_selecionar_status_comissao = _resolveComponent("selecionar-status-comissao")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_dados_conta_pagar = _resolveComponent("dados-conta-pagar")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: _ctx.telaBase.identificadorRecurso,
            tituloRecurso: _ctx.telaBase.titulo,
            exibirAtalhosTela: true,
            exisbirHistoricoTela: false,
            "empresas-selecionadas": [_ctx.state.filtros.empresa]
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Imprimir",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Word",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                  }, [
                    _createVNode(_component_icone, { nome: "word" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Excel",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                  }, [
                    _createVNode(_component_icone, { nome: "excel" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar CSV",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                  }, [
                    _createVNode(_component_icone, { nome: "download-arquivo" })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-secondary ss-btn-tela",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.gerarContaPagar && _ctx.gerarContaPagar(...args)))
                  }, _hoisted_7),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.buscarRelatorio && _ctx.buscarRelatorio(...args)))
                  }, _hoisted_9)
                ])
              ])
            ]),
            _: 1
          }, 8, ["identificadorRecurso", "tituloRecurso", "empresas-selecionadas"]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_spam, { class: "ss-selecionar-empresas" }, {
                    default: _withCtx(() => [
                      _createTextVNode("EMPRESAS")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.filtros.empresa,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.filtros.empresa) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Data",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_data_comissao, {
                            valor: _ctx.state.filtros.tipoData,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.filtros.tipoData) = $event)),
                            tipoRelatorio: _ctx.state.filtros.tipo
                          }, null, 8, ["valor", "tipoRelatorio"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_form_item, {
                        label: "Periodo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data_inicial_final, {
                            dataInicialSelecionada: _ctx.state.dataInicial,
                            "onUpdate:dataInicialSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                            dataFinalSelecionada: _ctx.state.dataFinal,
                            "onUpdate:dataFinalSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.dataFinal) = $event))
                          }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Comissão",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_comissao, {
                            valor: _ctx.state.filtros.tipo,
                            "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.filtros.tipo) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_a_form_item, {
                        label: "Colaborador",
                        class: "ss-margin-campo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_colaborador, {
                            empresas: [_ctx.state.filtros.empresa],
                            codigoSelecionado: _ctx.state.filtros.codigoVendedor,
                            "onUpdate:codigoSelecionado": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.filtros.codigoVendedor) = $event))
                          }, null, 8, ["empresas", "codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Status",
                        class: "ss-margin-campo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_status_comissao, {
                            valor: _ctx.state.filtros.status,
                            "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.filtros.status) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_20
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_card, { titulo: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_table, {
                      style: {"margin-bottom":"5px"},
                      columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                      "data-source": _ctx.state.itens,
                      rowKey: "codigoComissao",
                      pagination: false,
                      loading: _ctx.telaBase.carregando,
                      "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                      scroll: _ctx.gradeBase.layoutMobile?null: { y: _ctx.window.innerHeight - 345} 
                    }, {
                      headerCell: _withCtx(({ column }) => [
                        _createVNode(_component_coluna_grade, {
                          column: column,
                          ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                          "onUpdate:ordenacaoSelecionada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                          filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                          "onUpdate:filtrosCabecalho": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                          onBuscarDados: _ctx.buscarRelatorio
                        }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
                      ]),
                      bodyCell: _withCtx(({ record, column, text, }) => [
                        (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, true, true)), 1))
                          : (column.customRenderRow === _ctx.ECustomRenderRow.MascararPorcentagem)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2) + "%"), 1))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                              : (column.key === 'status')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.obterDescricaoStatus(record)), 1))
                                : (column.key === 'statusTitulo')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.obterDescricaoStatusFinanceiro(record)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(text), 1))
                      ]),
                      emptyText: _withCtx(() => [
                        _createVNode(_component_mensagem_sem_dados, {
                          resultadoPequisa: !_ctx.telaBase.carregando,
                          mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                        }, null, 8, ["resultadoPequisa", "mensagem"])
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source", "loading", "row-selection", "scroll"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_a_pagination, {
                          class: "ss-paginacao-completa",
                          current: _ctx.state.paginacao.current,
                          "onUpdate:current": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                          size: "small",
                          total: _ctx.state.paginacaoAPI.totalRegistros,
                          "show-total": _ctx.mostrarTotalPaginacao,
                          "page-size": _ctx.state.paginacao.pageSize,
                          pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                          onShowSizeChange: _ctx.onShowSizeChange,
                          showSizeChanger: _ctx.state.paginacao.showSizeChanger,
                          onChange: _ctx.onPageChange
                        }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "showSizeChanger", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
                            onKeyup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.keyupQuantidadeRegistroTotal && _ctx.keyupQuantidadeRegistroTotal(...args))),
                            placeholder: "Total registros",
                            type: "text",
                            class: "ant-input hidden"
                          }, null, 544), [
                            [_vModelText, _ctx.state.totalRegistrosComMascara],
                            [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                          ]),
                          _createElementVNode("span", _hoisted_32, [
                            _createVNode(_component_a_tooltip, { placement: "top" }, {
                              title: _withCtx(() => [
                                _hoisted_33
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_34, [
                                  _createVNode(_component_icone, { nome: "informacoes" })
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_totalizador_decorado, {
                          titulo: "TOTAL VENDAS",
                          cor: "white",
                          iconeColorido: false,
                          valor: _ctx.state.resultado.totalVendas,
                          monetario: true
                        }, null, 8, ["valor"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_totalizador_decorado, {
                          titulo: "TOTAL COMISSÃO",
                          cor: "white",
                          iconeColorido: false,
                          valor: _ctx.state.resultado.totalComissao,
                          monetario: true
                        }, null, 8, ["valor"])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_totalizador_decorado, {
                          titulo: "TOTAL SELECIONADO",
                          cor: "white",
                          iconeColorido: false,
                          valor: _ctx.state.totalSelecionado,
                          monetario: true
                        }, null, 8, ["valor"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivoPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_dados_conta_pagar, {
      visivel: _ctx.state.exibirContasPagar,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirContasPagar) = $event)),
      operacao: _ctx.state.operacaoLancamento,
      dados: _ctx.state.tituloFinanceiro,
      "onUpdate:dados": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.tituloFinanceiro) = $event)),
      onConfirmacao: _ctx.gerarContasPagar
    }, null, 8, ["visivel", "operacao", "dados", "onConfirmacao"])
  ], 64))
}